module.exports = __webpack_public_path__ + "static/media/sow-login-banner3.ca0d7690.png";